import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Avatar from "@mui/material/Avatar";
import PerformingAssetsCard from "../components/PerformingAssetsCard";
import { InsightSecondaryMetrics } from "../components/InsightMetricLines";
import { PLATFORMS_PLACEHOLDER } from "../../../../../i18n/keysTranslations";
import { useTranslationApp } from "../../../../../lib/i18next";
import { META } from "../../../../../utils/constants";
import { logoPlatform } from "../../../../../utils/string";
import logoThreads from "../../../../../assets/img/thread.webp";
import logoMessenger from "../../../../../assets/img/messenger.webp";
import logoWhatsapp from "../../../../../assets/img/whatsapp.webp";
import logoAudienceNetwork from "../../../../../assets/img/audience_network.webp";
import {
  buildInsightMetricCells,
  getBestPerformanceRow,
  getPublisherPlatformRowLabel,
} from "./MetaDemographicInsightsTables";
import { PERFORMING_ASSETS_BLUE } from "../components/performingAssetsStyles";

const PUBLISHER_PLATFORM_LOGOS = {
  threads: logoThreads,
  messenger: logoMessenger,
  whatsapp: logoWhatsapp,
  audience_network: logoAudienceNetwork,
};

const PublisherLabel = ({ name, platformKey, isBest = false }) => {
  const logo =
    PUBLISHER_PLATFORM_LOGOS[platformKey] || logoPlatform(platformKey);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        minWidth: 0,
        flex: 1,
      }}
    >
      {logo ? (
        <Avatar
          data-hide-in-pdf-capture
          src={logo}
          variant="square"
          sx={{
            width: 22,
            height: 22,
            flexShrink: 0,
            ".MuiAvatar-img": { objectFit: "contain" },
          }}
        />
      ) : (
        <Box
          sx={{
            width: 22,
            height: 22,
            borderRadius: "50%",
            bgcolor: "#E8EEF7",
            color: PERFORMING_ASSETS_BLUE,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "0.6875rem",
            fontWeight: 700,
            flexShrink: 0,
          }}
        >
          {String(name || "?").slice(0, 1)}
        </Box>
      )}
      <Typography
        variant="body2"
        noWrap
        sx={{
          fontWeight: 600,
          color: isBest ? PERFORMING_ASSETS_BLUE : "text.primary",
        }}
      >
        {name}
      </Typography>
    </Box>
  );
};

const MetaPublisherPlatformInsightsCard = ({
  publisherPlatformRows = [],
  getCostByMainCurrency,
}) => {
  const { t } = useTranslationApp();

  if (!publisherPlatformRows?.length) return null;

  const bestRow = getBestPerformanceRow(publisherPlatformRows);
  return (
    <PerformingAssetsCard
      platform={META}
      title={t(PLATFORMS_PLACEHOLDER)}
      nextContent={
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
          {publisherPlatformRows.map((row) => {
            const name = getPublisherPlatformRowLabel({
              publisherPlatform: row?.publisherPlatform,
              t,
            });
            const cells = buildInsightMetricCells({
              row,
              t,
              getCostByMainCurrency,
            });
            return (
              <Box key={name}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <PublisherLabel
                    platformKey={String(row?.publisherPlatform || "")
                      .trim()
                      .toLowerCase()}
                    name={name}
                    isBest={row === bestRow}
                  />
                </Box>
                <Box sx={{ pl: 4 }}>
                  <InsightSecondaryMetrics items={cells} />
                </Box>
              </Box>
            );
          })}
        </Box>
      }
    />
  );
};

export default MetaPublisherPlatformInsightsCard;
